<template>
  <img  v-if="isLoadingAudio"
    class="basis-1/4 flex items-center px-[20px] bg-[#ffffff] rounded-[30px] py-[20px]"
    src="@/assets/loading_dots.gif"
    alt="Loading"
  />
  <form v-else @submit.prevent="handleSubmit" class="basis-1/4 flex items-center px-[20px] bg-[#ffffff] rounded-[30px] py-[20px]">
    <textarea
      :value="input"
      @input="$emit('update:input', $event.target.value)"
      @keydown.enter.exact.prevent="handleSubmit"
      placeholder="Envía un mensaje a Richie IA"
      class="flex-1 resize-none h-full py-2 px-3 text-sm border-transparent [&:focus]:border-transparent [&:focus]:outline-none bg-white"
      lang="es"
      spellcheck="true"
    ></textarea>

    <button type="button" @click="toggleRecording" class="ml-2 text-blue-600 bg-transparent border-transparent">
      <img
        src="@/assets/microphone_icon.svg"
        alt="Send Audio"
        :class="['w-[30px]', isRecording ? 'animate-blink text-[#FF0000] filter-red' : '']"
      />
    </button>

    <!-- Submit Text Button -->
    <button
      type="submit"
      class="ml-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded bg-transparent border-transparent"
    >
      <img
        v-if="isLoading"
        src="@/assets/stop_button.png"
        alt="Send Button"
      />
      <img
        v-else
        src="@/assets/send_button.png"
        alt="Send Button"
      />
    </button>
  </form>
</template>

<script>
export default {
  props: {
    input: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isLoadingAudio: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'update:input', 'audioRecorded'],
  data(){
    return {
      isRecording: false
    }
  },
  methods: {
    handleSubmit() {
      this.$emit('submit')
    },
    async toggleRecording() {
      if (!this.isRecording) {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          console.log("🎤 Mic access OK", stream);

          this.mediaRecorder = new MediaRecorder(stream);
          this.audioChunks = [];

          this.mediaRecorder.ondataavailable = (e) => {
            this.audioChunks.push(e.data);
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
            this.$emit("audioRecorded", audioBlob);
          };

          this.mediaRecorder.start();
          this.isRecording = true;
        } catch (err) {
          console.error("❌ Mic access error", err);
          alert("Microphone access denied. Please check your browser settings.");
        }
      } else {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },
  }
}
</script>

<style>
@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
}

.animate-blink {
  animation: blink 1s infinite;
}

.filter-red {
  filter: brightness(0) saturate(100%) invert(14%) sepia(94%) saturate(7480%) hue-rotate(354deg) brightness(97%) contrast(122%);
}

</style>
